var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-grid-empty\">");t.b("\n" + i);t.b("   <div class=\"sma-grid-empty-message\">");t.b("\n" + i);t.b("      ");t.b(t.t(t.f("message",c,p,0)));t.b("\n" + i);t.b("   </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-grid-empty\">\n   <div class=\"sma-grid-empty-message\">\n      {{{ message }}}\n   </div>\n</div>\n", H);return T.render.apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/sma.admin/components/partials/grids/empty.mustache
// module id = 1581
// module chunks = 17